import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './JobJournal.css';
import jobjournalimage from '../../assets/pageimages/JobJournal.webp';

function JobJournalHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>JobJournal</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/myjournal/2" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="jobjournal-bottomlink-style" />My Job Journal</Link></div>
            <div className="bottom-buttons-box"><Link to="/tasks/add" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="jobjournal-bottomlink-style" />Add Journal Entry</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="jobjournal-id" src={jobjournalimage} alt="JobJournal Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default JobJournalHome;
